module.exports = __webpack_public_path__ + "assets/img/dzh-9.f8423263.jpg";